module.exports = __webpack_public_path__ + "img/infodesk_mobile.6862fdc9.svg";